import camelcase from 'camelcase';
import * as R from 'ramda';

type CamelCase = <T = string>(arg: T) => T;

export const camelcaseString: CamelCase = R.when<any, any>(
  R.is(String),
  (str) => camelcase(str, { preserveConsecutiveUppercase: true }),
);
